import script from "./Ticket.vue?vue&type=script&setup=true&lang=js"
export * from "./Ticket.vue?vue&type=script&setup=true&lang=js"

import "./Ticket.vue?vue&type=style&index=0&id=57f7848c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57f7848c"]])

export default __exports__